import React, { useState, useEffect } from 'react'

import { useHistory, Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import { ReactSession } from 'react-client-session'
import K from '../services/k'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEnvelope,
  faKey,
  faUtensils,
} from '@fortawesome/free-solid-svg-icons'
import FacebookLogin from 'react-facebook-login'
import GoogleLogin from 'react-google-login'

function Login(props) {
  const [theme, setTheme] = React.useState('')
  useEffect(() => {
    if (theme !== props.theme) {
      setTheme(props.theme)
    }
  }, [props.theme])

  const history = useHistory()
  const [deviceToken, setDeviceToken] = useState('')
  if (deviceToken !== props.deviceToken) {
    setDeviceToken(props.deviceToken)
  }

  //const dispatch = useDispatch();

  //const authResponse = useSelector(state=>state.userAuth.authResponse);
  const token = localStorage.getItem(['__react_session__'])

  const jsontoken = JSON.parse(token)
  if (jsontoken !== '' && jsontoken !== null) {
    if (jsontoken.api_token) {
      history.push('/')
    }
  }

  const [fields, setState] = useState({
    email: '',
    password: '',
  })

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleFieldChange = (e) => {
    setState({
      ...fields,
      [e.target.id]: e.target.value,
    })
  }

  const handleRememberMe = (e) => {}

  //please wait spinner
  const [spinnerStatus, setSpinnerStatus] = useState(0)
  const [spinnerMessage, setSpinnerMessage] = useState('')
  //redirect on successful register
  const [redirect, setredirect] = useState(0)

  const SaveFCMToken = async (id) => {
    const resp = await Axios.post(
      `${K.baseUrl}v1/notification/saveuser/${id}`,
      { device_key: deviceToken },
    )
  }

  const UserLogin = async (e) => {
    if (e) {
      e.preventDefault()
    }
    setSpinnerStatus(1)
    if (fields.email === '') {
      setSpinnerStatus(2)
      setSpinnerMessage('Email required')
      return false
    } else if (fields.password === '') {
      setSpinnerStatus(2)
      setSpinnerMessage('Password required')
      return false
    } else {
      const resp = await Axios.post(`${K.baseUrl}users/login`, fields)

      if (resp.data.resultcode === 0) {
        setSpinnerStatus(2)
        setSpinnerMessage(resp.data.message)
      } else if (resp.data.resultcode === 1) {
        localStorage.setItem('user-token', resp.data.api_token)
        localStorage.setItem('user_id', resp.data.user.id)
        ReactSession.setStoreType('localStorage')
        ReactSession.set('api_token', resp.data.api_token)
        ReactSession.set('user_id', resp.data.user.id)
        ReactSession.set('first_name', resp.data.user.firstname)
        ReactSession.set('last_name', resp.data.user.lastname)
        ReactSession.set('email', resp.data.user.email)

        ReactSession.set('membership', resp.data.membership)
        localStorage.setItem('user_email', resp.data.user.email)
        // await SaveFCMToken(resp.data.user.id);
        // <Redirect to="/restaurants" />
        window.location.href = '/restaurants'
        setredirect(1)
        setSpinnerStatus(3)
        setSpinnerMessage('Login successful')
      }
    }
    //dispatch(LoginAction(fields, history));
  }

  const UserLoginSocial = async (socialUser) => {
    setSpinnerStatus(1)
    if (socialUser.email === '') {
      setSpinnerStatus(2)
      setSpinnerMessage('Email required')
      return false
    } else if (socialUser.password === '') {
      setSpinnerStatus(2)
      setSpinnerMessage('Password required')
      return false
    } else {
      const resp = await Axios.post(`${K.baseUrl}users/login`, socialUser)

      if (resp.data.resultcode === 0) {
        setSpinnerStatus(2)
        setSpinnerMessage(resp.data.message)
      } else if (resp.data.resultcode === 1) {
        localStorage.setItem('user-token', resp.data.api_token)
        localStorage.setItem('user_id', resp.data.user.id)
        ReactSession.setStoreType('localStorage')
        ReactSession.set('api_token', resp.data.api_token)
        ReactSession.set('user_id', resp.data.user.id)
        ReactSession.set('first_name', resp.data.user.firstname)
        ReactSession.set('last_name', resp.data.user.lastname)
        ReactSession.set('email', resp.data.user.email)

        localStorage.setItem('user_email', resp.data.user.email)
        // await SaveFCMToken(resp.data.user.id);
        // <Redirect to="/restaurants" />
        window.location.href = '/restaurants'
        setredirect(1)
        setSpinnerStatus(3)
        setSpinnerMessage('Login successful')
      }
    }
    //dispatch(LoginAction(fields, history));
  }

  const responseFacebook = (response) => {
    try {
      var params = {
        first_name: response.name.split(' ')[0],
        last_name: response.name.split(' ')[1],
        phone_number: '1111',
        email: response.email,
        password: response.id,
        password_confirmation: response.id,
      }
      userRegister(params)
    } catch (error) {
      console.log(error)
    }
  }

  const componentClicked = (e) => {}

  const responseGoogle = (response) => {
    try {
      var params = {
        first_name: response.profileObj.givenName,
        last_name: response.profileObj.familyName,
        phone_number: '1111',
        email: response.profileObj.email,
        password: response.profileObj.googleId,
        password_confirmation: response.profileObj.googleId,
      }
      userRegister(params)
    } catch (error) {
      console.log(error)
    }
  }

  const userRegister = async (socialUser) => {
    setSpinnerStatus(1)

    const resp = await Axios.post(`${K.baseUrl}users/register`, socialUser)
    if (resp.data.resultcode === '0') {
      setState({
        email: socialUser.email,
        password: socialUser.password,
      })
      UserLoginSocial(socialUser)
    } else if (resp.data.resultcode === '1') {
      setState({
        email: socialUser.email,
        password: socialUser.password,
      })
      UserLoginSocial(socialUser)
    } else {
      setSpinnerStatus(2)
      setSpinnerMessage('Unexepected error occured.Consult system Admin')
    }
  }

  if (redirect === 1) {
    return <Redirect to="/" />
  } else {
    return (
      <div
        className={theme && theme === 'DARK' ? 'dark_theme' : 'light_theme'}
        style={{ marginBottom: '-90px' }}
      >
        <div className="main-wrapper__ inner--page">
          <section className="login">
            <div className="container">
              <div className="row formcontain">
                <div className="outterFormContainer col-lg-8 offset-lg-2 col-md-8 offset-md-2">
                  <div className="login-content">
                    <div className="heading-text text-center">
                      <h3>Log In</h3>
                      <p className="normalText">
                        ...and let&apos;s get you Ordering{' '}
                        <FontAwesomeIcon
                          style={{ color: '#42B749' }}
                          icon={faUtensils}
                        />
                      </p>
                    </div>
                    <div className="row formContainer">
                      <div className="smLogin">
                        <div className="social-btns">
                          {/* <a href="#" className="primary-btn google">
                        <svg style={{marginRight:'10px'}} aria-hidden="true" className="native svg-icon iconGoogle" width="18" height="18" viewBox="0 0 18 18"><path d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18Z" fill="#4285F4"></path><path d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17Z" fill="#34A853"></path><path d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07Z" fill="#FBBC05"></path><path d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.3Z" fill="#EA4335"></path></svg>Log in with Google
                        </a>
                        <a href="#" className="primary-btn fb">
                          
                          <FontAwesomeIcon icon={faFacebookSquare} style={{marginRight:'10px'}} />
                          Log in with Facebook
                        </a> */}
                          {/* <p style={{marginTop:'30px'}} className='normalText'>
                          <Link to="/signup"><b className='colorgreen'>Create an account</b> 
                          </Link> for free <br/> if you are new to RoadJockey</p> */}
                        </div>
                      </div>
                      <div className="login-form mr-5 ml-5">
                        <form onSubmit={UserLogin} className="mr-5 ml-5">
                          <div className="form-container">
                            <FontAwesomeIcon
                              style={{ position: 'absolute', margin: '15px' }}
                              icon={faEnvelope}
                            />
                            <input
                              type="email"
                              name="email"
                              id="email"
                              placeholder="Email"
                              value={fields.email}
                              onChange={handleFieldChange}
                              required
                            />
                          </div>
                          <div className="form-container">
                            <FontAwesomeIcon
                              style={{ position: 'absolute', margin: '15px' }}
                              icon={faKey}
                            />
                            <input
                              type="password"
                              name="Password"
                              id="password"
                              className="email"
                              placeholder="password"
                              value={fields.password}
                              onChange={handleFieldChange}
                              required
                            />
                          </div>
                          <div className="form-group text-left">
                            {spinnerStatus === 1 ? (
                              <span>
                                <p className="text-spinner-font">
                                  <i className="fa fa-spinner fa-spin spinner-font"></i>
                                  &nbsp;Please Wait...
                                </p>
                              </span>
                            ) : spinnerStatus === 2 ? (
                              <div className="alert alert-danger">
                                {spinnerMessage}
                              </div>
                            ) : spinnerStatus === 3 ? (
                              <div className="alert alert-success">
                                {spinnerMessage}
                              </div>
                            ) : (
                              <div></div>
                            )}
                          </div>
                          <div className="form-group text-center">
                            <div>
                              <input
                                type="checkbox"
                                name="RememberMe"
                                id="RememberMe"
                                className="RememberMe"
                                value=""
                                onChange={handleRememberMe}
                              />
                              <p className="logIn-actions">
                                <span className="colorgreen spaced">
                                  Remember me
                                </span>

                                <Link to="/forgotpassword">
                                  <span className="colorgreen">
                                    <b>Forgot password?</b>
                                  </span>
                                </Link>
                              </p>
                            </div>
                            <div>
                              <p className="logIn-actions">
                                <span className="colorgreen">
                                  by signing in you agree to our
                                </span>

                                <Link to="/termsandconditions">
                                  <span className="colorgreen">
                                    <b> Terms and Conditions</b>
                                  </span>
                                </Link>
                              </p>
                            </div>

                            <button
                              className="primary-btn mb-2 fwidth"
                              type="submit"
                            >
                              Login
                            </button>
                            <div className="social-btns">
                              <FacebookLogin
                                buttonStyle={{
                                  borderRadius: 5,
                                  width: '100%',
                                  display: 'block',
                                  height: '40px',
                                  padding: 0,
                                }}
                                appId="363448015724521"
                                autoLoad={false}
                                fields="name,email,picture"
                                onClick={componentClicked}
                                callback={responseFacebook}
                              />

                              <GoogleLogin
                                clientId="367462077380-uukdluktunfbjl6n32jt3u6jmukrnddm.apps.googleusercontent.com"
                                render={(renderProps) => (
                                  <button
                                    style={{
                                      borderRadius: 5,
                                      marginTop: 9,
                                      width: '100%',
                                      display: 'block',
                                      height: '40px',
                                      padding: 0,
                                    }}
                                    onClick={renderProps.onClick}
                                    disabled={renderProps.disabled}
                                    className="primary-btn google"
                                  >
                                    <svg
                                      style={{ marginRight: '10px' }}
                                      aria-hidden="true"
                                      className="native svg-icon iconGoogle"
                                      width="18"
                                      height="18"
                                      viewBox="0 0 18 18"
                                    >
                                      <path
                                        d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18Z"
                                        fill="#4285F4"
                                      ></path>
                                      <path
                                        d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17Z"
                                        fill="#34A853"
                                      ></path>
                                      <path
                                        d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07Z"
                                        fill="#FBBC05"
                                      ></path>
                                      <path
                                        d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.3Z"
                                        fill="#EA4335"
                                      ></path>
                                    </svg>
                                    Log in with Google
                                  </button>
                                )}
                                buttonText="Login"
                                onSuccess={responseGoogle}
                                onFailure={responseGoogle}
                                cookiePolicy={'single_host_origin'}
                              />
                            </div>
                          </div>
                          <p
                            style={{ marginTop: '30px' }}
                            className="normalText"
                          >
                            <Link to="/signup">
                              <b className="colorgreen">Create an account</b>
                            </Link>{' '}
                            for free <br /> if you are new to RoadJockey
                          </p>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }
}

export default Login
